import { type FC } from "react";

import { isVideoSrcExtension } from "../../lens-preview/validation";

import { LensCardEmptyPreview, LensCardImg, LensCardVideo } from "./shared";

export const TopLensPreview: FC<{ preview: string }> = ({ preview }) => {
    if (!preview) {
        return <LensCardEmptyPreview />;
    }

    if (isVideoSrcExtension(preview)) {
        return (
            <LensCardVideo width="100%" height="100%" autoPlay={true} muted={true}>
                <source src={preview} />
            </LensCardVideo>
        );
    }

    return <LensCardImg src={preview} />;
};
